   <div class="modal" *transloco="let t; read:'permit'">
        <div class="modal__content">
            <div class="wheel__datetime-picker">
                <div div class="wheel__datetime-picker__controls">
                    <div class="wheel__column" (wheel)="onWheel($event, 'date')" (mousedown)="onDragStart($event, 'date')" (touchstart)="onTouchStart($event, 'date')">
                        <div class="wheel__highlight first"></div>
                        <div class="wheel__items" [style.transform]="'translateY(' + dateOffset + 'px)'">
                        <div *ngFor="let date of dateOptions; let i = index" class="wheel__item" [class.wheel__item--selected]="selectedDateIndex === i" (click)="selectDate(i)">
                            {{ formatDate(date) }}
                        </div>
                        </div>
                    </div>
                    <div class="wheel__column" (wheel)="onWheel($event, 'hour')" (mousedown)="onDragStart($event, 'hour')" (touchstart)="onTouchStart($event, 'hour')">
                        <div class="wheel__highlight"></div>
                        <div class="wheel__items" [style.transform]="'translateY(' + hourOffset + 'px)'">
                        <div *ngFor="let hour of hours; let i = index" class="wheel__item" [class.wheel__item--selected]="selectedHourIndex === i" (click)="selectHour(i)">
                            {{ hour.toString().padStart(2, '0') }}
                        </div>
                        </div>
                    </div>
                    <div>:</div>
                    <div class="wheel__column" (wheel)="onWheel($event, 'minute')" (mousedown)="onDragStart($event, 'minute')" (touchstart)="onTouchStart($event, 'minute')">
                        <div class="wheel__highlight last"></div>
                        <div class="wheel__items" [style.transform]="'translateY(' + minuteOffset + 'px)'">
                        <div *ngFor="let minute of minutes; let i = index" class="wheel__item" [class.wheel__item--selected]="selectedMinuteIndex === i" (click)="selectMinute(i)">
                            {{ minute.toString().padStart(2, '0') }}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal__actions">
                    <button class="modal__actions__close" type="button" (click)="close()">{{ t("close") }}</button>
        </div>
</div>
